module.exports = __webpack_public_path__ + "img/TALLER TRABAJOS ESPECIALES.f75ca73b.png";